// extracted by mini-css-extract-plugin
module.exports = {"info":"DYHIA4ziW2du"};